import {put, takeLatest, delay} from 'redux-saga/effects';
import {searchQueryChanged, setSearchQuery} from './searchAndFilterSlice';

function* handleSearchQuery(action) { // Update the search query in the Redux state
    yield delay(10); // debounce
    const searchQuery = action.payload;
    yield put(setSearchQuery(searchQuery));
}

export function* watchSearchFilterSaga() {
    yield takeLatest(searchQueryChanged, handleSearchQuery); // Listen for searchQueryChanged actions and call handleSearchQuery
}
